/*
 * @Description:接口请求
 * @Version: 2.0
 * @Autor: daikeyi
 * @Date: 2020-06-05 15:25:04
 * @LastEditors: daikeyi
 * @LastEditTime: 2021-01-20 11:29:32
 */
import Vue from 'vue';
import { ESVNet,ESVStorage } from 'esvcp-mobile';
import { Toast } from 'vant';
// let channelType = 'WECHAT';

const wUrl = window.location.href;
const dz_url = wUrl.split('#')[0]; // 获取#/之前的字符串
const cs_url = dz_url.split('?');
let cs = {};
if (cs_url && cs_url.length >= 2) {
    cs = dz_url.split('?')[1]; // 获取?之后的参数字符串
    const cs_arr = cs.split('&'); // 参数字符串分割为数组
    cs = {};
    for (var i = 0; i < cs_arr.length; i++) { // 遍历数组，拿到json对象
        cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1];
    }
}

const channelType = cs.channelType || 'WECHAT';

ESVNet.setCommonParamsFunc(params => {
    if (Vue.config.performance) {
        // params.develop = true;
        params.develop = false;
    }
    params.channelType = channelType;
    ESVStorage.getSessionValue('secret', (data) => {
        params.secret = data;
    });

    ESVStorage.getSessionValue('shortCode', (data) => {
        params.shortCode = data;
    });
});
const commonServerErrorCallback = (data) => {
    if (data.responseCode === '990000') {
        const url = window.location.href;
        const openPage = url.split('/#/')[0] + '/#/OPSysMaintenance';
        window.location.href = openPage;
    }
    if (data.responseCode === '10001004') {
        const url = window.location.href;
        const openPage = url.split('/#/')[0] + '/#/OPHomeNew';
        window.location.href = openPage;
        window.esvcp.store.dispatch(
            'setMerchantInfo'
        );
    }
    Toast(data.message);
};

ESVNet.setRequestMethod('post');

export const doRequest = (
    doAjaxObj,
    succCallback,
    serverErrorCallback,
    localErrorCallback
) => {
    const errorCallback = (data) => {
        commonServerErrorCallback(data);
        serverErrorCallback && serverErrorCallback(data);
    };

    ESVNet.doRequest(
        doAjaxObj,
        succCallback,
        errorCallback,
        localErrorCallback
    );
};
